import React from "react";
import { ActivityFormQuizNoMemberContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import VerifyOTPModalContainer from "containers/VerifyOTPModalContainer";
import { Forms, Headers, Icons, Modals } from "components";

class ActivityFormQuizNoMemberContainer extends React.Component {
  state = {};

  handleCloseModal = () => {
    this.setState({
      renderModal: false,
    });
  };

  handleSubmit = (values) => {
    const { onSubmit } = this.props;
    let params = { ...values, member_type: "3" };
    // onSubmit(params)
    this.setState({
      tempValues: params,
      renderModal: (
        <VerifyOTPModalContainer
          memberType={"3"}
          phoneNumber={values.personal_phone_number}
          email={values.personal_email}
          onCancel={this.handleCloseModal}
          onVerifySuccess={() => {
            this.handleCloseModal();
            onSubmit(params);
          }}
        />
      ),
    });
  };

  render() {
    const { renderModal } = this.state;
    return (
      <ActivityFormQuizNoMemberContainerStyled>
        <Headers.PageHeader
          icons={<Icons.ActivityCircle />}
          title={"ACTIVITY : Online form"}
          subTitle={"กิจกรรม: แบบฟอร์มออนไลน์"}
        />
        <Forms.PersonalInfoNoMemberForm onSubmit={this.handleSubmit} />
        <Modals.BodyEmpty
          isShowModal={!!renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </ActivityFormQuizNoMemberContainerStyled>
    );
  }
}

export default withRouter(ActivityFormQuizNoMemberContainer);
